import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import questionGroups from 'modules/surveys/store/collections/questionGroups'

interface QuestionGroupsParams {
  formId: string | null | undefined
  respondentId?: string | null | undefined
}

export function useQuestionGroups({ formId, respondentId }: QuestionGroupsParams) {
  const { loading } = useAsyncData(async () => {
    if (!formId) return

    return questionGroups.fetch({
      data: {
        surveys_form_id: formId,
        respondent_id: respondentId,
      },
    })
  }, [formId, respondentId])

  return {
    loading,
    questionGroups: questionGroups.filter({
      surveys_form_id: formId,
    }),
  }
}
